export default "__VITE_ASSET__0e4bad7b__"